import React, { useState } from 'react';
import emailBlockBgDark from '../assets/png/email_block_bg-dark.png';
import { ReactComponent as SubmitIcon } from '../assets/svg/submit_icon.svg';
import { useSendEmail } from '../hooks/useSendEmail';
import { ButtonWithCheck } from './Button';
import { Spinner } from './Spinner';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewsletterBlock: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const { mutate: sendEmail, isSuccess, isError, error, isPending } = useSendEmail();
  // console.log({ error });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    const isValidEmail = !!emailRegex.test(email);

    e.preventDefault();
    if (!isValidEmail) return;
    sendEmail(email);
  };

  return (
    <div className="relative w-full md:w-[724px] h-auto md:h-[157px]">
      <div className="relative h-full border border-contrast-7 dark:border-contrast-3 rounded-lg bg-white/50 dark:bg-contrast-2 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-azul/5 via-transparent to-transparent" />

        {/* Background texture for dark mode - positioned on bottom */}
        <div
          className="hidden dark:block absolute h-full bottom-0 opacity-30"
          style={{
            backgroundImage: `url(${emailBlockBgDark})`,
            backgroundSize: 'auto 100%',
            backgroundPosition: 'right -8px top -8px',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />

        {/* Content wrapper with proper padding */}
        <div className="relative px-4 md:px-6 py-6 md:py-8 h-full flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-0">
          {/* Left side - Text content */}
          <div className="flex flex-col gap-3 w-full md:w-[268px]">
            <h3 className="text-contrast-3 dark:text-contrast-8 text-[16px] md:text-[18px] font-medium font-geist">
              Don't miss out!
            </h3>
            <p className="text-contrast-4 dark:text-contrast-6 text-[12px] font-geist leading-[18px]">
              👉 Join our mailing list to stay updated on the latest features and upcoming Velora
              campaigns.
            </p>
          </div>
          {/* Right side - Email input form */}

          <form onSubmit={handleSubmit} className="w-full md:w-auto flex items-center">
            <div className="relative h-12 w-full md:w-[344px]">
              <input
                type="email"
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full h-full bg-contrast-8 dark:bg-contrast-1 border-[1px] border-contrast-7 dark:border-contrast-3 rounded-md text-contrast-4 dark:text-contrast-6 text-[12px] font-geist px-4 outline-none placeholder:text-contrast-5 placeholder:italic focus:border-[1px] focus:border-primary-azul dark:focus:border-primary-azul focus:bg-white dark:focus:bg-contrast-1 transition-all"
              />
              {/* Submit button positioned inside input */}
              {isSuccess ? (
                <ButtonWithCheck disabled />
              ) : (
                <button
                  // disabled={!isValidEmail}
                  type="submit"
                  className="absolute right-1 top-1 h-10 w-12 flex items-center justify-center bg-primary-azul rounded-md hover:bg-opacity-90 transition-all"
                >
                  {isPending ? <Spinner /> : <SubmitIcon className="w-6 h-6" />}
                </button>
              )}
              {error?.message && (
                <div className="text-contrast-4 dark:text-contrast-6 text-[12px] font-geist leading-[18px]">
                  {error?.message}
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsletterBlock;
